import React from 'react';

export const ANCHOR: React.CSSProperties = {
  position: 'fixed',
  left: '1%',
  top: 'auto',
  bottom: '3%',
  transform: 'translate(0, 0)',
  margin: 0,
  animation: 'none',
  transition: 'none',
};
